import { useEffect } from 'react';
import { loadSession, createUserBatchSession } from '../services/accountAbstractionService';
import { setLoadingRedeemSession, setRedeemBatchSession } from '../store/accountAbstractionActions';
import { useAccountAbstractionDispatch, useAccountAbstractionStore } from '../store/AccountAbstractionContext';
import { SESSION_KEYS } from '../store/accountAbstractionActions';
import { createRedeemSessionParams } from '../lib/createRedeemSessionParams';
import config from '@/common/config';

export const useRedeemBatchSession = () => {
  const dispatch = useAccountAbstractionDispatch();
  const accountAbstractionStore = useAccountAbstractionStore();

  const { smartAccount, sessionKeyAddress, sessionStorageClient, loadingRedeemSession, redeemBatchSession } =
    accountAbstractionStore?.state;

  useEffect(() => {
    const createRedeemSession = async () => {
      if (!config.smartWalletEnabled) return;

      if (smartAccount && sessionKeyAddress && sessionStorageClient && !redeemBatchSession && !loadingRedeemSession) {
        dispatch(setLoadingRedeemSession(true));
        try {
          let batchSession = await loadSession(smartAccount, SESSION_KEYS.REDEEM_SESSION);
          if (!batchSession) {
            const { newSession } = await createUserBatchSession(
              smartAccount,
              sessionStorageClient,
              createRedeemSessionParams(sessionKeyAddress),
            );
            batchSession = newSession;
          }
          dispatch(setRedeemBatchSession(batchSession));
        } catch (error) {
          console.error('Error creating redeem session', error);
        } finally {
          dispatch(setLoadingRedeemSession(false));
        }
      }
    };
    createRedeemSession();
  }, [smartAccount, sessionKeyAddress, sessionStorageClient, dispatch, redeemBatchSession, loadingRedeemSession]);
};
